import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "SUBMIT REQUEST",
    body: "File a mission briefing through the request form. Tell us the target (service), the coordinates (address), and the situation on the ground.",
  },
  {
    num: "02",
    title: "RAPID RESPONSE",
    body: "Command reviews your briefing and confirms your service call window within 24 hours. You get a straight answer, not a runaround.",
  },
  {
    num: "03",
    title: "MISSION COMPLETE",
    body: "A uniformed crew arrives on schedule, executes the repair or installation, and leaves the site cleaner than they found it.",
  },
];

export const HowItWorks = () => (
  <section id="protocol" className="border-t border-olive-deep bg-olive-deep/20 py-24 sm:py-32" data-testid="protocol-section">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <p className="overline-tactical text-coyote mb-4" data-testid="protocol-overline">OP-FIX // 03 // FIELD PROTOCOL</p>
      <h2 className="font-display uppercase text-4xl sm:text-6xl tracking-tight mb-16" data-testid="protocol-heading">
        How The <span className="text-khaki">Mission</span> Runs
      </h2>
      <div className="grid md:grid-cols-3 gap-px bg-olive-deep border border-olive-deep">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="bg-obsidian p-8 sm:p-10"
            data-testid={`protocol-step-${s.num}`}
          >
            <span className="font-display text-6xl text-olive">{s.num}</span>
            <h3 className="mt-6 font-bold tracking-[0.15em] text-khaki text-sm">{s.title}</h3>
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
